import "./style.scss";

import { randomNumber, getNearValues, sendMetric, getWhatId } from "@utils";
import { inject, observer } from "mobx-react";
import { useEffect, useMemo, useState } from "react";
import { FORTUNE_TIMING, getFortuneCountExitMs } from "../timings";
import grats from "./img/grats.gif";
import slot from "./img/slot.gif";

const ITEM_H = 200;
const OVERSHOOT_PX = 200;
const COUNT_WORDS = "Считаем сколько у вас подарков".split(" ");
const GRATS_WORDS = "Ура! У вас есть 5 минут на выбор".split(" ");
const { VITE_WHAT_ID } = import.meta.env;
export const FORTUNE_WORD_COUNT = COUNT_WORDS.length;

const Fortune = inject("mainStore")(
    observer(({ mainStore, timings }) => {
        const offersList = mainStore.getMainStore("offersList");
        const { offers = [] } = offersList;
        const settingLego = mainStore.getMainStore("settingLego");
        const wdCd = mainStore.getMainStore("codeTypeMetrika");
        const abTestMetika =  mainStore.getMainStore("abTestMetika");
        


        const fortuneTiming = timings?.fortune || FORTUNE_TIMING;
        const countExitMs = getFortuneCountExitMs(FORTUNE_WORD_COUNT, fortuneTiming);
        const what_id = getWhatId() ? getWhatId() : VITE_WHAT_ID;

        const numberOffer = offers.length || 8;

        const [prizes, setPrizes] = useState([]);
        const [offset, setOffset] = useState(0);
        const [phase, setPhase] = useState("");
        const [isTrackIntro, setIsTrackIntro] = useState(true);
        const [titlePhase, setTitlePhase] = useState("count");

        const stopIndex = useMemo(() => {
            if (!prizes.length) return 0;
            return Math.max(0, prizes.length - 4);
        }, [prizes.length]);

        useEffect(() => {
            const randomPrizes =
                settingLego?.queueRandomness === false
                    ? [...getNearValues(numberOffer, 14), ...getNearValues(numberOffer - 2, 2)]
                    : [...Array.from({ length: 14 }, () => randomNumber(1, numberOffer)), numberOffer, ...Array.from({ length: 3 }, () => randomNumber(1, numberOffer))];
            setPrizes(randomPrizes);
        }, [offers.length, numberOffer]);

        useEffect(() => {
            if (!prizes.length) return;

            const startIndex = Math.min(3, Math.max(0, prizes.length - 1));
            const startOffset = startIndex * ITEM_H;
            const target = stopIndex * ITEM_H;
            const overshoot = target + OVERSHOOT_PX;

            setOffset(startOffset);
            setIsTrackIntro(true);

            const t0 = setTimeout(() => {
                setIsTrackIntro(false);
                requestAnimationFrame(() => {
                    setPhase("spin");
                    setOffset(overshoot);
                });
            }, fortuneTiming.introMs);

            const t1 = setTimeout(() => {
                setPhase("settle");
                setOffset(target);
                sendMetric(`widget_step_2_show`, {
                    params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                    params2: null,
                    params3: null,
                    params4: null,
                    params6: null,
                    params7: wdCd ? wdCd : null,
                    params8: what_id,
                });
            }, fortuneTiming.introMs + fortuneTiming.spinMs);

            const t2 = setTimeout(
                () => {
                    setPhase("idle");
                },
                fortuneTiming.introMs + fortuneTiming.spinMs + fortuneTiming.settlePauseMs,
            );

            return () => {
                clearTimeout(t0);
                clearTimeout(t1);
                clearTimeout(t2);
            };
        }, [prizes.length, stopIndex, fortuneTiming.introMs, fortuneTiming.spinMs, fortuneTiming.settlePauseMs]);

        const isIdle = phase === "idle";

        useEffect(() => {
            if (!isIdle) {
                sendMetric(`widget_step_2_show`, {
                    params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                    params2: null,
                    params3: null,
                    params4: null,
                    params6: null,
                    params7: wdCd ? wdCd : null,
                    params8: `${what_id}`,
                });

                if (window.risMetrika && typeof window.risMetrika.reachgoal_ch === "function") {
                    window.risMetrika.reachgoal_ch({
                        event: "widget_step_2_show",
                        siteId: what_id, //'id витрины',
                        session_uuid: localStorage.getItem("_r_p_s"),
                        widget_code: wdCd ? wdCd : "",
                    });
                }

                setTitlePhase("count");
                return;
            }

            setTitlePhase("count-exit");
            const t1 = setTimeout(() => {
                setTitlePhase("grats-enter");
            }, countExitMs);

            return () => clearTimeout(t1);
        }, [isIdle, countExitMs]);

        return (
            <div className="fortune-ai">
                <img src={isIdle ? grats : slot} className="fortune-ai__slot" alt="" />
                <div className="fortune-ai__titles">
                    <span className={`fortune-ai__title fortune-ai__title_count ${titlePhase === "count" ? "is-show" : ""} ${titlePhase === "count-exit" ? "is-exit" : ""} ${titlePhase.startsWith("grats") ? "is-hidden" : ""}`}>
                        {COUNT_WORDS.map((word, idx) => (
                            <span key={`${word}-${idx}`} className="fortune-ai__title-word" style={{ "--delay": `${idx * fortuneTiming.titleStepMs}ms` }}>
                                {word}
                            </span>
                        ))}
                    </span>
                    <span className={`fortune-ai__title fortune-ai__title_grats ${titlePhase === "grats-enter" ? "is-enter" : ""} ${titlePhase === "count" || titlePhase === "count-exit" ? "is-hidden" : ""}`}>
                        {GRATS_WORDS.map((word, idx) => (
                            <span key={`${word}-${idx}`} className="fortune-ai__title-word" style={{ "--delay": `${idx * fortuneTiming.titleStepMs}ms` }}>
                                {word}
                            </span>
                        ))}
                    </span>
                </div>

                <div className="fortune-ai__viewport">
                    <div className={`fortune-ai__track-wrap ${isTrackIntro ? "is-intro" : ""}`} style={{ "--intro-ms": `${fortuneTiming.titleAnimMs}ms` }}>
                        <div className={`fortune-ai__track ${phase}`} style={{ transform: `translate3d(0, -${offset}px, 0)` }}>
                            {prizes.map((p, idx) => (
                                <span key={idx} className={`fortune-ai__prize ${(phase === "settle" || isIdle) && idx === stopIndex ? "fortune-ai__prize_highlight" : ""}`}>
                                    {p}
                                </span>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        );
    }),
);

export default Fortune;
